import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import QualysContainerSecurityConfigListing from "./QualysContainerSecurityConfigListing";
import QualysContainerSecurityCredentialsForm from "./QualysContainerSecurityCredentialsForm";

const QualysContainerSecurityPullAndPushView = (props) => (
  <GenericPullAndPushToolView
    {...props}
    PullCredentialForm={QualysContainerSecurityCredentialsForm}
    PullConfigListingView={QualysContainerSecurityConfigListing}
  />
);

export default QualysContainerSecurityPullAndPushView;
